import React from 'react';
import styles from 'sections/works/works.module.css';
import { useTranslation } from 'react-i18next';

import { IWork } from 'sections/works/interfaces';
import { LaptopIcon } from 'components/vectors/LaptopIcon';
import { CrossIcon } from 'components/vectors/CrossIcon';

interface IWorksPopupProps {
    item: IWork;
    onClose: () => void;
    children: JSX.Element;
}

export const WorksPopup = ({ item, onClose, children }: IWorksPopupProps) => {
    const { t } = useTranslation();

    const { title, subtitle, popupText, popupInfo, websiteUrl } = item;
    const openWebsite = () => {
        window.open(websiteUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className={styles.item__popup}>
            <button className={styles.popup__closeIcon} onClick={onClose}>
                <CrossIcon />
            </button>
            <div className={`${styles.item__img} ${styles.item__img_popup}`}>
                {children}
            </div>
            <h4 className={styles.item__title}>{title}</h4>
            <p className={styles.item__subtitle}>{subtitle}</p>
            <p className={styles.item__text}>{popupText}</p>
            <div className={styles.item__info}>
                <div>
                    <LaptopIcon />
                </div>
                <p>{popupInfo}</p>
            </div>

            {websiteUrl && (
                <button className={styles.item__button} onClick={openWebsite}>
                    <span>{t('works.popupViewWebsiteBtnText')}</span>
                </button>
            )}
        </div>
    );
};
